import React from 'react';
import './About.css';

const About = () => {
  const appName = process.env.REACT_APP_NAME || 'UltraCoder IDE';
  const appVersion = process.env.REACT_APP_VERSION || '2.0.0';

  const milestones = [
    { year: '2021', event: 'UltraCoder founded with a vision to revolutionize developer tooling using AI.' },
    { year: '2022', event: 'First public beta released. 10,000 developers sign up within the first week.' },
    { year: '2023', event: 'Launched AI Code Generation engine powered by GPT-4. Series A funding secured.' },
    { year: '2024', event: 'Reached 500,000+ active developers. Real-time collaboration feature launched.' },
    { year: '2025', event: `${appName} v2.0 released with full AI integration, security scanner, and cloud sync.` },
  ];

  const team = [
    { name: 'Alex Chen', role: 'CEO & Co-Founder', emoji: '👨‍💻', expertise: 'AI/ML Systems' },
    { name: 'Sarah Kim', role: 'CTO & Co-Founder', emoji: '👩‍🔬', expertise: 'Compiler Design' },
    { name: 'Marcus Rivera', role: 'Head of AI', emoji: '🧠', expertise: 'LLM Engineering' },
    { name: 'Priya Patel', role: 'Lead Designer', emoji: '🎨', expertise: 'Dev UX Research' },
  ];

  return (
    <section className="about" id="about">
      <div className="about__container">

        {/* About Header */}
        <div className="about__header">
          <div className="about__badge">🚀 About UltraCoder</div>
          <h2 className="about__title">
            Built by developers, <br />
            <span className="about__title-gradient">for developers</span>
          </h2>
          <p className="about__description">
            {appName} was born from a simple belief: writing code should feel magical.
            We combine cutting-edge AI with deep developer empathy to create an IDE
            that thinks alongside you — not just for you.
          </p>
        </div>

        {/* Mission Cards */}
        <div className="about__mission">
          <div className="mission-card">
            <div className="mission-card__icon">🎯</div>
            <h3>Our Mission</h3>
            <p>Empower every developer — from beginner to expert — to build software faster,
              safer, and with more confidence using the power of AI assistance.</p>
          </div>
          <div className="mission-card">
            <div className="mission-card__icon">👁️</div>
            <h3>Our Vision</h3>
            <p>A world where the barrier between an idea and working software is measured
              in minutes, not months — democratizing software creation for everyone.</p>
          </div>
          <div className="mission-card">
            <div className="mission-card__icon">💎</div>
            <h3>Our Values</h3>
            <p>Transparency, performance, and developer happiness above all else.
              Every feature we ship must make real developers genuinely more productive.</p>
          </div>
        </div>

        {/* Timeline */}
        <div className="about__timeline-section">
          <h3 className="about__section-title">Our Journey</h3>
          <div className="about__timeline">
            {milestones.map((m, i) => (
              <div key={i} className="timeline-item">
                <div className="timeline-item__year">{m.year}</div>
                <div className="timeline-item__line">
                  <div className="timeline-item__dot"></div>
                  {i < milestones.length - 1 && <div className="timeline-item__connector"></div>}
                </div>
                <div className="timeline-item__content">{m.event}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Team */}
        <div className="about__team-section">
          <h3 className="about__section-title">Meet the Team</h3>
          <div className="about__team">
            {team.map((member, i) => (
              <div key={i} className="team-card">
                <div className="team-card__avatar">{member.emoji}</div>
                <h4 className="team-card__name">{member.name}</h4>
                <p className="team-card__role">{member.role}</p>
                <span className="team-card__expertise">{member.expertise}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Version Info Banner */}
        <div className="about__version-banner">
          <div className="about__version-info">
            <span className="about__version-label">Current Version</span>
            <span className="about__version-number">v{appVersion}</span>
          </div>
          <div className="about__version-divider"></div>
          <div className="about__version-info">
            <span className="about__version-label">Platform</span>
            <span className="about__version-number">Cross-Platform</span>
          </div>
          <div className="about__version-divider"></div>
          <div className="about__version-info">
            <span className="about__version-label">License</span>
            <span className="about__version-number">MIT / Pro</span>
          </div>
          <div className="about__version-divider"></div>
          <div className="about__version-info">
            <span className="about__version-label">Support</span>
            <span className="about__version-number">24/7 AI Help</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;